<template>
  <el-container  class="height100">
    <el-main class="el-mainContent paddingLeft0 height100 overflowYHidden" v-show="showMode=='LIST'"  ref="managerMain">
      <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight"  ref="normalHeight">
        <el-col :span="12" class="normalLineH">{{$t('calendarList')}}</el-col>
        <el-col :span="12" class="align-right normalLineH">
          <span class="toolbar-buttons">
            <el-button type="primary" @click="onAddBtnClick" size="small">{{$t('new')}}</el-button>
            <el-button @click="onDeleteBtnClick" size="small" type="danger" plain>{{$t('remove')}}</el-button>
          </span>
        </el-col>
      </el-row>
      <el-row  ref="search">
        <el-col :span="16">
          <el-form :inline="true" :model="searchdata" class="form-inline" size="mini"  @submit.native.prevent>
            <el-form-item >
              <el-input v-model="searchdata.data.name" :placeholder="$t('calendarName')" @keyup.enter.native="searchTableData"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="searchTableData" type="primary" plain>{{$t('query')}}</el-button>
              <el-button @click="resetSearchTableData">{{$t('reset')}}</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- 工作日历列表 -->
      <el-table :data="calendars.datas"
        ref="multipleTable"
        :row-key="handleReserve"
        @row-click="onRowClick"
        @selection-change="handleSelectionChange"
        header-cell-class-name="tableHeaderbg"
        class="Trpointer "
        size="small"
        :height="tableListConHeight">
        <!-- @row-click="onRowClick" -->
        <el-table-column type="selection" width="55" ></el-table-column>
        <el-table-column prop="name" :label="$t('calendarName')"></el-table-column>
        <el-table-column prop="remark" :label="$t('description')"></el-table-column>
        <el-table-column prop="level" :label="$t('operating')">
          <template slot-scope="scope">
            <el-button @click.stop="onEditBtnClick(scope.row)" type="primary" plain size="mini">{{$t('edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="searchTableData"
        :current-page.sync="searchdata.currpage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="searchdata.pagelines"
        :page-count="4"
        layout="prev, pager, next, total, sizes"
        background
        :total="calendars.rowCount?calendars.rowCount:0"
        ref="pagination"
      ></el-pagination>
    </el-main>

    <calendar_edit :visible.sync="newCalendar" @new-ok="onNewCalendarOk"  :detail="content" :nowOption="nowOption" v-if="newCalendar"/>
    <calendar_detail  @exit="onExitDetail" v-show="showMode=='DETAIL'" :detail="detail" v-if="showMode=='DETAIL'"/>

  </el-container>
</template>

<script>
import calendar_edit from "@/components/calendar_edit.vue";
import calendar_detail from "@/components/calendar_detail.vue";

export default {
  components:{
    calendar_edit,
    calendar_detail,
  },
  created() {
    this.searchTableData();
  },
   mounted(){
    // var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.tableListConHeight=this.$refs.managerMain.$el.getClientRects()[0].height-this.$refs.normalHeight.$el.getClientRects()[0].height-this.$refs.search.$el.getClientRects()[0].height-this.$refs.pagination.$el.getClientRects()[0].height;
   
  },
  data() {
    return {
      calendars: [],
      searchdata:{
        domainid: this.$route.query.domainid,
        currpage: 1,
        pagelines: 10,
        data:{
          name:"",
        }
      },
      multipleTable:[],
      multipleSelection:[],
      newCalendar:false,
      content:{
        name:"",
        _calendarid:"",
        remark:""
      },
      nowOption:"change",
      calendarsSort:[],
      showMode:"LIST",
      detail:[],
      tableListConHeight:null,
    };
  },
  methods:{
    resetSearchTableData(){
      this.searchdata.data.name='';
      this.searchTableData();
    },
    handleSelectionChange(val){
      var arr = [];
       val.forEach((val) => {
        this.calendars.datas.forEach((v) => {
          if(val.id == v.id){
            arr.push(val.id)
          }
        })
      })   
      this.multipleSelection = arr;
    },
    handleReserve(row){
      return row.id
    },
    handleSizeChange(size){
      this.searchdata.pagelines=size;
      this.searchTableData();
    },
    searchTableData(){
      this.$api.getDomainCalendars(
        this.searchdata,
        {
          onSucess: resp => {
            this.calendars = resp.data.data;
          }
        }
      );
    },
    onAddBtnClick(){
      this.content={};
      this.nowOption="new"
      this.newCalendar=true;
      
    },
    onDeleteBtnClick(){
      if(this.multipleSelection.length>0){
        this.$confirm('请确认是否删除选中日历?', '提示', {
          confirmButtonText: this.$t('confirm'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }).then(() => {
          this.$api.deleteCalendars({
            data:this.multipleSelection
          },{
            onSucess:resp =>{
              if(resp.data.errcode==0){
                this.$message({
                    showClose: true,
                    message: this.$t('msg_del_success'),
                    type: "success"
                  });
                this.searchdata={
                  domainid: this.$route.query.domainid,
                  currpage: 1,
                  pagelines: 10,
                  data:{
                    name: "",
                  }
                },
                this.searchTableData();
              }else{
                this.$message({
                  showClose: true,
                  message: resp.data.errmsg,
                  type: "error"
                });
              }
            },
            onError:function(){
              this.$message({
                showClose: true,
                message: this.$t('msg_del_failed'),
                type: "error"
              }); 
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('msg_cancel_del'),
          });          
        });
        
      }else{
        this.$message({
          showClose: true,
          message: this.$t('请选择一个日历进行删除'),
          type: "error"
        });
      }
    },
    onNewCalendarOk(){
      this.searchTableData();
    },
    onEditBtnClick(row) {
      this.content=JSON.parse(JSON.stringify(row));
      this.nowOption="change";
      this.newCalendar=true;
    },
    onRowClick(row){
      this.showMode="DETAIL"
      this.detail=row;
    },
    onExitDetail(){
      this.showMode="LIST"
      this.searchTableData();
    }
  }

};
</script>

<style>
</style>